module.exports = __webpack_public_path__ + "img/JTB-min.eebde2fb.png";